module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper repaymentplan"
  }, [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("还款计划")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    class: {
      noTop: _vm.isWechat
    }
  }, [_c('div', {
    staticClass: "plan-list"
  }, _vm._l((_vm.repaymentPlanList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v("到期日期: ")]), _vm._v(" "), _c('span', {
      staticClass: "date decimal"
    }, [_vm._v(_vm._s(item.endDate))]), _vm._v(" "), _c('a', {
      staticClass: "repaymentstatus",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.status))])]), _vm._v(" "), _c('div', {
      staticClass: "item-group clearfix"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-value"
    }, [_c('div', {
      staticClass: "value decimal"
    }, [_vm._v(_vm._s(item.principal == null ? '--' : item.principal))]), _vm._v(" "), _c('div', {
      staticClass: "value decimal"
    }, [_vm._v(_vm._s(item.normalInterest == null ? '--' : item.normalInterest)), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.unit))])])])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-group clearfix"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "item-value"
    }, [_c('div', {
      staticClass: "value decimal"
    }, [_vm._v(_vm._s(item.remainPrincipal == null ? '--' : item.remainPrincipal))]), _vm._v(" "), _c('div', {
      staticClass: "value decimal"
    }, [_vm._v(_vm._s(item.phaseNum == null ? '--' : item.phaseNum))])])])])
  }))]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-label"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("应还本金")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("应还利息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-label"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("剩余本金")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("期数")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c128ee3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/repaymentplan.vue
// module id = 367
// module chunks = 1